module.exports = __webpack_public_path__ + "img/gold.e901db26.png";